import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";
import { checkIsListingClassesType } from "./checkIsListingClassesType";

/**
 * This function returns whether we need to show the renew subscription form to the user
 * @param param0 isRenewSubscription this is there in url params or not
 * @param param1 listingType, listing type
 * @param param2 subscriptionDays, count of subscription days in case of Qpp Subscription
 * @returns if the listing is of renew subscription or not
 */
export const getRenewSubscriptionAvailable = ({
    isRenewSubscription,
    listingType,
    subscriptionDays,
}: {
    isRenewSubscription: boolean;
    listingType: number;
    subscriptionDays?: number;
}) => {
    if (isRenewSubscription) {
        if (listingType === LISTING_TYPES.NO_SCHEDULE && subscriptionDays) {
            return true;
        }
        if (checkIsListingClassesType({ listingType })) {
            return true;
        }
        if (
            listingType === LISTING_TYPES.BRANDED_COMMUNITY ||
            listingType === LISTING_TYPES.WHATSAPP ||
            listingType === LISTING_TYPES.TELEGRAM
        ) {
            return true;
        }
    }
    return false;
};
